module.exports = __webpack_public_path__ + "static/media/icon-save.3aaf7139.svg";